export enum PointShape {
    circle,
    triangle,
    square,
    diamond,
    star,
    polygon
}